import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const SidebarCtx = createContext({
  collapsed: false,
  toggle: () => {},
  mobileOpen: false,
  openMobile: () => {},
  closeMobile: () => {},
  toggleMobile: () => {},
});

const isDesktop = () =>
  typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches;

export const SidebarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem("medily.sidebar") === "1"; } catch { return false; }
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try { localStorage.setItem("medily.sidebar", collapsed ? "1" : "0"); } catch (_) {}
  }, [collapsed]);

  // Auto-close mobile drawer whenever the route changes
  useEffect(() => { setMobileOpen(false); }, [location.pathname, location.search]);

  const toggle = () => {
    if (isDesktop()) setCollapsed((c) => !c);
    else setMobileOpen((o) => !o);
  };
  const openMobile = () => setMobileOpen(true);
  const closeMobile = () => setMobileOpen(false);
  const toggleMobile = () => setMobileOpen((o) => !o);

  return (
    <SidebarCtx.Provider value={{ collapsed, toggle, mobileOpen, openMobile, closeMobile, toggleMobile }}>
      {children}
    </SidebarCtx.Provider>
  );
};

export const useSidebar = () => useContext(SidebarCtx);
